import React from 'react';
import { PROJECT_TITLE_HELPER_TEXT, PROJECT_TITLE_INPUT_TEST_ID, PROJECT_TITLE_LABEL } from '../../forms/scholarly-project/constants';
import { Input, Section } from '../Shared';
import { CITING_SECTION_TITLE } from './constants';

/** Scholarly project citing section id and testId */
export var SECTION_ID = 'scholarly-project-citing-section';
export var SECTION_TEST_ID = 'scholarly-project-citing-section-test-id';
export var ScholarlyProjectCitingSection = function ScholarlyProjectCitingSection() {
  return /*#__PURE__*/React.createElement(Section, {
    sectionId: SECTION_ID,
    title: CITING_SECTION_TITLE,
    ariaLabelledby: "".concat(SECTION_ID, "-label"),
    dataTestId: SECTION_TEST_ID
  }, /*#__PURE__*/React.createElement(Input, {
    type: "text",
    name: "scholarlyproject.title",
    labelText: PROJECT_TITLE_LABEL,
    "data-test": PROJECT_TITLE_INPUT_TEST_ID,
    helperText: PROJECT_TITLE_HELPER_TEXT
  }));
};